import ScopeGroupName from "./ScopeGroupName";
import ScopeGroupLink from "./ScopeGroupLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ScopeGroupDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="ScopeGroup-detail-title"
                    >
                        { label || t`Scope Group` }: <ScopeGroupName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="ScopeGroup-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="ScopeGroup-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="hierarchyName-label" sx={{ textAlign: "left" }}><Trans>Hierarchy Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="hierarchyName-value" sx={{ textAlign: "left" }}>{ data.hierarchyName || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="scopeGroupContext-label" sx={{ textAlign: "left" }}><Trans>Scope Group Context</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="scopeGroupContext-value" sx={{ textAlign: "left" }}>{ data.scopeGroupContext || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="parentScopeGroupId-label" sx={{ textAlign: "left" }}><Trans>Scope Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="parentScopeGroupId-value" sx={{ textAlign: "left" }}>{ data.parentScopeGroupId ? (<ScopeGroupLink id={ data.parentScopeGroupId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="membersGroupId-label" sx={{ textAlign: "left" }}><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="membersGroupId-value" sx={{ textAlign: "left" }}>{ data.membersGroupId ? (<MembersGroupLink id={ data.membersGroupId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ScopeGroupDetail;
